import styled from "@emotion/styled";
import { motion } from "framer-motion";
import React from "react";
import { STRINGS } from "../../strings";
import { translate } from "../../translate";
import { MEDFLYT_LOGO_ICON_ONLY } from "../../utils/svgs_new";
import { AppIcon } from "../Generic/AppIcon";
import { Notification } from "./InAppNotifications";

type Props = {
  notification: Notification;
  onClick: (notification: Notification) => void;
  onAnimationComplete: (notification: Notification) => void;
};

const PUSH_NOTIFICATION_DURATION = 6000;

const InAppNotification = (props: Props) => {
  return (
    <Root onClick={() => props.onClick(props.notification)}>
      <Wrapper>
        <InfoIcon>
          <AppIcon icon={MEDFLYT_LOGO_ICON_ONLY} />
        </InfoIcon>
        <Content>
          <strong>{translate(STRINGS.MEDFLYT_TEAM)}</strong>
          <span>{props.notification.message}</span>
        </Content>
      </Wrapper>
      <Progress>
        <motion.div
          initial={{ width: 0, backgroundColor: "var(--blue-dark-softest)" }}
          animate={{ width: "100%", backgroundColor: "var(--primary-color)" }}
          transition={{ duration: PUSH_NOTIFICATION_DURATION / 1000, ease: "linear" }}
          onAnimationComplete={() => props.onAnimationComplete(props.notification)}
        />
      </Progress>
    </Root>
  );
};

const Root = styled.div`
  background-color: white;
  box-shadow: 0px 4px 32px rgba(0, 0, 0, 0.2);
  border-radius: 16px;
  margin: 12px;
  overflow: hidden;
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 12px;
`;

const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;

  > strong {
    font-weight: 700;
  }

  > span {
    font-size: 14px;
    color: var(--gray-700);
  }
`;

const InfoIcon = styled.div`
  --wrapper-size: 52px;
  --icon-size: 20px;
  background-color: var(--primary-softest-color);
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: var(--wrapper-size);
  height: var(--wrapper-size);

  border-radius: 100%;

  > svg {
    width: var(--icon-size);
    height: var(--icon-size);

    > path {
      fill: var(--blue-dark);
    }
  }
`;

const Progress = styled.div`
  height: 3px;
  background-color: var(--blue-dark-softest);
  border-radius: var(--progress-radius);
  overflow: auto;

  > div {
    height: 100%;
    background-color: var(--gray-200);
  }
`;

export default InAppNotification;
